import React from "react";
import {Info} from "@mui/icons-material";
import PageTitle from "./layout/PageTitle.js";
import ButtonCreate from "./layout/ButtonCreate.js";
import Loader from "./layout/loading/loader.js";
import Constants from "../../utils/constants.js";
import {toastHelper} from "../../utils/toast-helper.js";
import ConsigneTable from "./referentiel/consignes/ConsigneTable.js";
import {useGetConsignesQuery, useDeleteConsigneMutation} from "../../modules/consignes/consignes.api.js";
import {Stack} from "@mui/material";

export default function ConsignesPage() {
    const {data: consignes = [], isLoading} = useGetConsignesQuery();
    const [deleteConsigne] = useDeleteConsigneMutation();

    const handleDelete = async (c) => {
        try {
            await deleteConsigne(c.id).unwrap();
            toastHelper.displaySuccess("La consigne a bien été supprimée.");
        } catch (e) {
            toastHelper.handleError(e, "Oops, une erreur est survenue.");
        }
    };

    return (
        <>
	        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
		        <PageTitle title={"Consignes"} icon={<Info/>}/>
		        <ButtonCreate route={Constants.APP_ROUTE_ADMIN_CONSIGNES_NEW} label={"Ajouter une consigne"} />
	        </Stack>

            {isLoading ? <Loader/> : <ConsigneTable consignes={consignes} onDelete={handleDelete}/>}
        </>
    );
}
